import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';

import { OomphService } from '../../../services/oomph/oomph.service';

@Component({
  selector: 'sn-oom-header',
  templateUrl: './oom-header.component.html',
  styleUrls: ['./oom-header.component.css']
})
export class OomHeaderComponent implements OnInit {

  public screenHeight:number = 50;
  public currentViewClass:any = {
    view_oom_dashboard: 'nav-item',
    view_oom_payments: 'nav-item',
    view_oom_chat: 'nav-item',
  }

  constructor(
    public router: Router,
    public oomphService: OomphService
  ) {
  }

  ngOnInit() {
    this.oomphService.currentView.subscribe(
      (currentView) => {
        for (var p in this.currentViewClass) {
            this.currentViewClass[p] = "nav-item";
          if (p == currentView) {
            this.currentViewClass[p] = "nav-item active";
          }
        }
      }
    );
  }

  public routingTable:any = {
  //view                url
    view_oom_dashboard:  'oomph/dashboard',
    view_oom_payments:   'oomph/payments',
    view_oom_chat:       'oomph/chat',
  }

  public navigate(view) {
    if (this.routingTable[view]) {
      this.router.navigateByUrl(this.routingTable[view]);
    }
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/oomph/oom-header/oom-header.component.ts